import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from '../store';

const BASE_API = process.env.REACT_APP_BASE_API;

interface IAnyResponse {
  [key: string]: any;
}

interface IDetailsPayload {
  lang: string;
}

export const detailsSlice = createApi({
  reducerPath: 'details',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as RootState).isAuth.isAuth;
      const lang = (getState() as RootState).language.lang;
      const publicEndpoints = ['getDetails'];
      const isPublic = publicEndpoints.includes(endpoint);
      if (token && !isPublic) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('Accept-Language', lang);
      return headers;
    }
  }),
  tagTypes: ['Details'],
  endpoints: (builder) => ({
    getDetails: builder.query<IAnyResponse, IDetailsPayload>({
      query: (payload) => ({
        url: `/detail`,
        method: 'GET'
      })
    })
  })
});

export const { useGetDetailsQuery } = detailsSlice;
